import createAnimation from "../converter";
import blinkData from "../blendDataBlink.json";
import { sRGBEncoding } from "three/src/constants";
import { useEffect, useMemo, useState } from "react";
import { useFrame } from "@react-three/fiber";
import { MeshStandardMaterial } from "three/src/materials/MeshStandardMaterial";
import { useGLTF, useTexture, useFBX, useAnimations } from "@react-three/drei";
import axios from "axios";
import _ from "lodash";
import * as THREE from "three";
import { dbRefs } from "../db";
import { set, onValue } from "firebase/database";
import ModelLoadingStatus from "../tutor/modelLoadingStatus";
import { analytics } from "../firebase";
import { logEvent } from "firebase/analytics";

const host = `https://vvul7gq6wb.execute-api.eu-north-1.amazonaws.com/${process.env.REACT_APP_ENV_TYPE}`;

const pageInitTime = Date.now();

function makeSpeech(text) {
  const urlParams = new URLSearchParams(window.location.search);
  const idToken = urlParams.get("token");
  if (!idToken) return;
  return axios.post(host + "/talk", { text, idToken });
}

export default function Avatar({
  avatar_url,
  speak,
  setSpeak,
  text,
  setAudioSource,
  playing,
  user,
}) {
  let gltf = useGLTF(avatar_url);
  let morphTargetDictionaryBody = null;
  let morphTargetDictionaryLowerTeeth = null;
  let eyelashesMorphTargetDictionary = null;

  const [
    bodyTexture,
    eyesTexture,
    armsTexture,
    nailsTexture,
    eyelashesTexture,
    teethTexture,
    hairTexture,
    sweaterTexture,
  ] = useTexture([
    "/images/body.webp",
    "/images/eyes.webp",
    "/images/arms.webp",
    "/images/nails.webp",
    "/images/eyelashes.webp",
    "/images/teeth.webp",
    "/images/hair.webp",
    "/images/sweater.webp",
  ]);

  _.each(
    [
      bodyTexture,
      eyesTexture,
      armsTexture,
      nailsTexture,
      eyelashesTexture,
      teethTexture,
      hairTexture,
      sweaterTexture,
    ],
    (t) => {
      t.encoding = sRGBEncoding;
      t.flipY = false;
    }
  );

  gltf.scene.traverse((node) => {
    if (
      node.type === "Mesh" ||
      node.type === "LineSegments" ||
      node.type === "SkinnedMesh"
    ) {
      node.castShadow = true;
      node.receiveShadow = true;
      node.frustumCulled = false;

      if (node.name.includes("Body")) {
        node.castShadow = true;
        node.receiveShadow = true;

        node.material = new MeshStandardMaterial();
        node.material.color = new THREE.Color(0x000000);
        node.material.map = null;
        node.material.emissiveMap = bodyTexture;
        node.material.emissive = new THREE.Color(0xffffff);
        node.material.roughness = 1.0;
        node.material.emissiveIntensity = 1.0;
        node.material.side = THREE.DoubleSide;
        node.material.blending = THREE.NormalBlending;
        node.material.transparent = false;
        node.material.depthWrite = true;
        node.material.depthTest = true;
        morphTargetDictionaryBody = node.morphTargetDictionary;

        console.log(node.geometry.attributes.uv);

        node.material.envMapIntensity = 0.8;
      }

      if (node.name.includes("Eyes")) {
        node.material = new MeshStandardMaterial();
        node.material.color = new THREE.Color(0xffffff);
        node.material.map = eyesTexture;
        // node.material.emissiveMap = eyesTexture;
        node.material.roughness = 0.75;
        node.material.emissiveIntensity = 0;
        node.material.emissive = new THREE.Color(0xffffff);
        node.material.side = THREE.DoubleSide;
        node.material.blending = THREE.NormalBlending;
        node.material.transparent = false;
        node.material.depthWrite = true;
        node.material.depthTest = true;

        node.material.envMapIntensity = 0.8;
      }

      if (node.name.includes("Eyes_1")) {
        node.material = new THREE.MeshPhysicalMaterial();
        node.material.color = new THREE.Color(0xffffff);
        node.material.roughness = 0.75;
        node.material.map = eyesTexture;
        // node.material.emissiveMap = eyesTexture;
        node.material.emissiveIntensity = 0;
        node.material.emissive = new THREE.Color(0xffffff);
        node.material.reflectivity = 0.85;
        node.material.ior = 2.0;
        node.material.roughness = 0.05;
        node.material.opacity = 0.5;
        node.material.side = THREE.FrontSide;
        node.material.blending = THREE.NormalBlending;
        node.material.transparent = true;
        node.material.depthWrite = true;
        node.material.depthTest = true;
        // morphTargetDictionaryBody = node.morphTargetDictionary;

        node.material.envMapIntensity = 0.8;
      }

      if (node.name.includes("Arms")) {
        node.material = new MeshStandardMaterial();
        node.material.color = new THREE.Color(0x000000);
        node.material.map = null;
        node.material.emissiveMap = armsTexture;
        node.material.roughness = 1.0;
        node.material.emissiveIntensity = 1.0;
        node.material.emissive = new THREE.Color(0xffffff);
        node.material.side = THREE.DoubleSide;
        node.material.blending = THREE.NormalBlending;
        node.material.transparent = false;
        node.material.depthWrite = true;
        node.material.depthTest = true;
        // morphTargetDictionaryBody = node.morphTargetDictionary;

        node.material.envMapIntensity = 0.8;
      }

      if (node.name.includes("Nails")) {
        node.material = new MeshStandardMaterial();
        node.material.color = new THREE.Color(0x000000);
        node.material.map = null;
        node.material.emissiveMap = nailsTexture;
        node.material.roughness = 1.0;
        node.material.emissiveIntensity = 1.0;
        node.material.emissive = new THREE.Color(0xffffff);
        node.material.side = THREE.DoubleSide;
        node.material.blending = THREE.NormalBlending;
        node.material.transparent = false;
        node.material.depthWrite = true;
        node.material.depthTest = true;
        // morphTargetDictionaryBody = node.morphTargetDictionary;

        node.material.envMapIntensity = 0.8;
      }

      if (node.name.includes("Eyelashes")) {
        node.castShadow = true;
        node.receiveShadow = true;

        node.material = new MeshStandardMaterial();
        node.material.color = new THREE.Color(0x000000);
        node.material.map = eyelashesTexture;
        node.material.emissiveMap = eyelashesTexture;
        node.material.roughness = 0.75;
        node.material.emissiveIntensity = 1.0;
        node.material.emissive = new THREE.Color(0xffffff);
        node.material.side = THREE.DoubleSide;
        node.material.blending = THREE.NormalBlending;
        node.material.transparent = true;
        node.material.depthWrite = true;
        node.material.depthTest = true;

        node.material.envMapIntensity = 0.8;

        eyelashesMorphTargetDictionary = node.morphTargetDictionary;
      }

      if (node.name.includes("Teeth")) {
        node.material = new MeshStandardMaterial();
        node.material.color = new THREE.Color(0x000000);
        node.material.map = teethTexture;
        node.material.emissiveMap = teethTexture;
        node.material.roughness = 1.0;
        node.material.emissiveIntensity = 0.5;
        node.material.emissive = new THREE.Color(0xffffff);
        node.material.side = THREE.DoubleSide;
        node.material.blending = THREE.NormalBlending;
        node.material.transparent = false;
        node.material.depthWrite = true;
        node.material.depthTest = true;
        // morphTargetDictionaryBody = node.morphTargetDictionary;

        node.material.envMapIntensity = 0.8;

        morphTargetDictionaryLowerTeeth = node.morphTargetDictionary;
      }

      if (node.name.includes("Hair")) {
        node.castShadow = true;
        node.receiveShadow = true;

        node.material = new MeshStandardMaterial();
        // node.material.color = new THREE.Color(0xffffff);
        node.material.map = hairTexture;
        node.material.emissiveMap = hairTexture;
        node.material.roughness = 1.0;
        node.material.emissiveIntensity = 1.0;
        node.material.emissive = new THREE.Color(0xffffff);
        node.material.side = THREE.DoubleSide;
        node.material.blending = THREE.NormalBlending;
        node.material.transparent = true;
        node.material.depthWrite = false;
        node.material.depthTest = true;
        node.material.opacity = 1.0;

        node.renderOrder = 10;

        node.material.envMapIntensity = 0.8;
      }

      if (node.name.includes("Sweater")) {
        node.material = new MeshStandardMaterial();
        node.material.color = new THREE.Color(0x000000);
        node.material.map = sweaterTexture;
        node.material.emissiveMap = sweaterTexture;
        node.material.roughness = 1.0;
        node.material.emissiveIntensity = 1.0;
        node.material.emissive = new THREE.Color(0xffffff);
        node.material.side = THREE.DoubleSide;
        node.material.blending = THREE.NormalBlending;
        node.material.transparent = false;
        node.material.depthWrite = true;
        node.material.depthTest = true;
        // morphTargetDictionaryBody = node.morphTargetDictionary;

        node.material.envMapIntensity = 0.8;
      }
    }
  });

  useEffect(() => {
    const directionalLight = new THREE.DirectionalLight(0xffffff, 3);
    directionalLight.position.set(5, 10, 7.5);
    directionalLight.castShadow = true;
    directionalLight.shadow.radius = 0.5;
    gltf.scene.add(directionalLight);

    const ambientLight = new THREE.AmbientLight(0xaaaaaa, 2);
    gltf.scene.add(ambientLight);
  }, []);

  useEffect(() => {
    if (!user) return;
    const loadingSeconds = ((Date.now() - pageInitTime) / 1000).toFixed(1);
    if (analytics) {
      logEvent(analytics, "modelLoaded", {
        loading_seconds: loadingSeconds,
      });
    }
    const urlParams = new URLSearchParams(window.location.search);
    const userId = urlParams.get("userId");
    const roomId = urlParams.get("roomId");
    if (!userId || !roomId) return;
    const modelLoadingStatusRef = dbRefs.chatStateModelLoadingStatusRef(
      userId,
      roomId
    );

    // первый раз помечаем LOADED
    set(modelLoadingStatusRef, ModelLoadingStatus.LOADED);

    // слушаем изменения и восстанавливаем LOADED, если что
    const unsubscribe = onValue(modelLoadingStatusRef, (snap) => {
      if (snap.val() !== ModelLoadingStatus.LOADED) {
        set(modelLoadingStatusRef, ModelLoadingStatus.LOADED);
      }
    });

    return unsubscribe;
  }, [user]);

  const [clips, setClips] = useState([]);
  const mixer = useMemo(() => new THREE.AnimationMixer(gltf.scene), []);

  useEffect(() => {
    if (speak === false) {
      clips.forEach((clip) => {
        let clipAction = mixer.clipAction(clip);
        clipAction.stop();
      });
      return;
    }
    const promise = makeSpeech(text);
    if (!promise) {
      setSpeak(false);
      return;
    }
    promise
      .then((response) => {
        let { blendData, filename } = response.data;

        let newClips = [
          createAnimation(blendData, morphTargetDictionaryBody, "HG_Body"),
          createAnimation(
            blendData,
            morphTargetDictionaryLowerTeeth,
            "HG_TeethLower"
          ),
        ];

        filename = host + filename;

        setClips(newClips);
        setAudioSource(filename);
      })
      .catch((err) => {
        console.error(err);
        setSpeak(false);
      });
  }, [speak]);

  let idleFbx = useFBX("/idle.fbx");
  let { clips: idleClips } = useAnimations(idleFbx.animations);

  // const tracks = idleClips[0].tracks.map((track) => track.name)

  idleClips[0].tracks = _.filter(idleClips[0].tracks, (track) => {
    return (
      track.name.includes("mixamorigHead.quaternion") ||
      track.name.includes("mixamorigSpine.quaternion") ||
      track.name.includes("mixamorigLeftShoulder.quaternion") ||
      track.name.includes("mixamorigRightShoulder.quaternion") ||
      track.name.includes("mixamorigLeftArm.quaternion") ||
      track.name.includes("mixamorigRightArm.quaternion") ||
      track.name.includes("mixamorigRightForeArm.quaternion") ||
      track.name.includes("mixamorigLeftForeArm.quaternion")
    );
  });

  useEffect(() => {
    let idleClipAction = mixer.clipAction(idleClips[0]);
    idleClipAction.play();

    let clips = [
      createAnimation(blinkData, morphTargetDictionaryBody, "HG_Body"),
      createAnimation(
        blinkData,
        eyelashesMorphTargetDictionary,
        "HG_Eyelashes"
      ),
    ];

    _.each(clips, (clip) => {
      let clipAction = mixer.clipAction(clip);
      clipAction.play();
    });
  }, []);

  // Play animation clips when available
  useEffect(() => {
    if (playing === false) return;

    _.each(clips, (clip) => {
      let clipAction = mixer.clipAction(clip);
      clipAction.setLoop(THREE.LoopOnce);
      clipAction.play();
    });
  }, [playing]);

  useFrame((state, delta) => {
    mixer.update(delta);
  });

  const isPortrait = window.innerHeight > window.innerWidth;

  return (
    <group name="avatar" position={isPortrait ? [0, 0.3, 0.3] : [0, 0.22, 0.5]}>
      <primitive object={gltf.scene} dispose={null} />
    </group>
  );
}
